import React from "react";
import "./footer.css";
import { PROVIDER_URL, HOSPITAL_URL } from "../../Service/AxiosConfig";
import logo from "../Assets/footer-logo.png";
import img1 from "../Assets/ig.png";
import img2 from "../Assets/fb.png";
import img3 from "../Assets/tt.png";
import img4 from "../Assets/li.png";
import img5 from "../Assets/wa.png";

import { FaMapMarkerAlt, FaPhone, FaRegCalendar } from "react-icons/fa";
import { Link } from "react-router-dom";
import { IoCallOutline } from "react-icons/io5";
import { MdMailOutline } from "react-icons/md";
import { useNavigate, useLocation } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const handleScrollToTop = (e, path) => {
    e.preventDefault();

    if (location.pathname === path) {
      const root = document.getElementById("root") || document.documentElement;
      const start = root.scrollTop || window.scrollY;
      const duration = 500; // in ms
      const startTime = performance.now();

      const animate = (currentTime) => {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);
        const ease = 1 - Math.pow(1 - progress, 3);
        const scrollTo = start * (1 - ease);

        root.scrollTop = scrollTo;

        if (progress < 1) {
          requestAnimationFrame(animate);
        } else {
          document.body.scrollTop = 0;
          document.documentElement.scrollTop = 0;
        }
      };

      requestAnimationFrame(animate);
    } else {
      navigate(path, { state: { scrollTo: "top" } });
    }
  };

  return (
    <footer className="">
      <div className="footer">
        <div className="footer-container">
          <div className="footer-section description-section">
            <div className="logo">
              <img
                src={logo}
                alt="Logo"
                onClick={(e) => handleScrollToTop(e, "/")}
                style={{ cursor: "pointer" }}
              />
            </div>
            <p>
              We are Hyderabad’s largest network of CarePreneurs. As a
              CarePreneurs network, we empower skilled individuals to deliver
              care with ownership, empathy, and excellence transforming homes
              into healing spaces and families into partners in recovery.
            </p>
            <div className="footer-contact">
              <p>
                <a href="tel:+919669668687" style={{ textDecoration: "none", color: "#fff", display: "flex", alignItems: "center", gap: "6px" }}>
                  <IoCallOutline />
                  +91 966 966 8687
                </a>
              </p>
              <p>
                <a
                  href="mailto:care@wihan.in"
                  style={{
                    textDecoration: "none",
                    color: "#fff",
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                  }}
                >
                  <MdMailOutline /> care@wihan.in
                </a>

              </p>

              <p>
                <FaMapMarkerAlt /> Plot No: 22 & 23, Saket, Vorla Enclave, ECIL,
                Secunderabad, Hyderabad, Telangana- 500062.{" "}
              </p>
            </div>
          </div>

          <div className="footer-section">
            <h3>Quick Links</h3>
            <ul>
              <li>
                <a href="/" onClick={(e) => handleScrollToTop(e, "/")}>Home</a>
              </li>
              <li>
                <a href="/about" onClick={(e) => handleScrollToTop(e, "/about")}>About</a>
              </li>
              <li>
                <Link to="/blog" onClick={(e) => handleScrollToTop(e, "/blog")}>Blog</Link>
              </li>
              <li>
                <Link onClick={() => window.open(HOSPITAL_URL, "_blank")}>Hospital Network</Link>
              </li>

              <li>
                <Link onClick={() => window.open(PROVIDER_URL, "_blank")}>Join Our Network</Link>
              </li>
              <li >
                <Link to="/contact" onClick={(e) => handleScrollToTop(e, "/contact")}>Contact Us</Link>
              </li>
              <li>
                <Link
                  to="/privacy-policy"
                  onClick={(e) => handleScrollToTop(e, "/privacy-policy")}
                >
                  Privacy Policy
                </Link>
              </li>

              <li>
                <Link
                  to="/terms-and-conditions"
                  onClick={(e) => handleScrollToTop(e, "/terms-and-conditions")}
                >
                  Terms and Conditions
                </Link>
              </li>
              <li>
                <Link
                  to="/account-deletion-policy"
                  onClick={(e) => handleScrollToTop(e, "/account-deletion-policy")}
                >
                  Account deletion policy
                </Link>
              </li>

            </ul>
          </div>

          <div className="footer-section">
            <h3>Services</h3>
            <ul>
              <li >
                <Link to="/home-nurse" onClick={(e) => handleScrollToTop(e, "/home-nurse")}>Home Nurse</Link>
              </li>
              <li >
                <Link to="/baby-care" onClick={(e) => handleScrollToTop(e, "/baby-care")}>Baby Care</Link>
              </li>
              <li  >
                <Link to="/care-giver" onClick={(e) => handleScrollToTop(e, "/care-giver")}>Care Giver</Link>
              </li>
              <li >
                <Link to="/home-icu-setup" onClick={(e) => handleScrollToTop(e, "/home-icu-setup")}>Home ICU Setup</Link>
              </li>
              <li>
                <Link to="/doctor-consultation" onClick={(e) => handleScrollToTop(e, "/doctor-consultation")}>Doctor Consultations</Link>
              </li>
              <li >
                <Link to="/health-checks" onClick={(e) => handleScrollToTop(e, "/health-checks")}>Health Checks</Link>
              </li>
              <li >
                <Link to="/physiotherapy" onClick={(e) => handleScrollToTop(e, "/physiotherapy")}>Physiotherapy</Link>
              </li>
              <li >
                <Link to="/medical-equipment" onClick={(e) => handleScrollToTop(e, "/medical-equipment")}>Medical Equipments</Link>
              </li>
              <li>
                <Link to="/medicine-home-delivery" onClick={(e) => handleScrollToTop(e, "/medicine-home-delivery")}>Medicine Home Delivery</Link>
              </li>
              <li >
                <Link to="/radiology" onClick={(e) => handleScrollToTop(e, "/radiology")}>Radiology</Link>
              </li>
              <li >
                <Link to="/diagnostics" onClick={(e) => handleScrollToTop(e, "/diagnostics")}>Diagnostics</Link>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div>
          Copyright © {new Date().getFullYear()} Wihan (A Unit Of Acuvera Care Private Limited). All Rights Reserved.
        </div>
        <div className="footer-images">
          <Link to="https://www.instagram.com/wihan_homecare/" target="_blank">
            <img src={img1} alt="img" /></Link>

          <Link to="https://www.facebook.com/profile.php?id=61581308447571" target="_blank">
            <img src={img2} alt="img" /></Link>

          <Link to="https://x.com/Wihan_home" target="_blank">
            <img src={img3} alt="img" /></Link>  <Link>

            <img src={img4} alt="img" /></Link>
          <Link  >
            <img src={img5} alt="img" />   </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
